import { Twitter, Linkedin, Heart, MessageCircle } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="relative py-16 px-6 border-t border-border/30 bg-background/80 backdrop-blur-sm">
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/5 to-primary/10 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto">
        {/* Main Message */}
        <div className="text-center mb-8">
          <p className="text-lg md:text-xl text-foreground/90 mb-2">
            Still brainstorming? Drop us a DM on X{' '}
            <a
              href="https://twitter.com/layout_dev"
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent hover:text-accent/80 font-semibold transition-colors"
            >
              @layout_dev
            </a>
            {' '}— we read every message.
          </p>
          <p className="text-base md:text-lg text-muted-foreground">
            Let's build the next billion-dollar SaaS together.
          </p>
        </div>

        {/* Social Icons */}
        <div className="flex items-center justify-center gap-4 mb-8">
          <a
            href="https://twitter.com/layout_dev"
            target="_blank"
            rel="noopener noreferrer"
            className="group p-3 rounded-lg bg-card/50 border border-border/30 hover:border-accent/50 transition-all hover:shadow-[0_0_20px_rgba(96,165,250,0.3)]"
            aria-label="Twitter"
          >
            <Twitter className="w-5 h-5 text-muted-foreground group-hover:text-accent transition-colors" />
          </a>
          <a
            href="https://www.linkedin.com/company/layout-dev"
            target="_blank"
            rel="noopener noreferrer"
            className="group p-3 rounded-lg bg-card/50 border border-border/30 hover:border-accent/50 transition-all hover:shadow-[0_0_20px_rgba(96,165,250,0.3)]"
            aria-label="LinkedIn"
          >
            <Linkedin className="w-5 h-5 text-muted-foreground group-hover:text-accent transition-colors" />
          </a>
          <a
            href="https://discord.gg/sdSzHeznmU"
            target="_blank"
            rel="noopener noreferrer"
            className="group p-3 rounded-lg bg-card/50 border border-border/30 hover:border-accent/50 transition-all hover:shadow-[0_0_20px_rgba(96,165,250,0.3)]"
            aria-label="Discord"
          >
            <MessageCircle className="w-5 h-5 text-muted-foreground group-hover:text-accent transition-colors" />
          </a>
        </div>

        {/* Powered By */}
        <div className="text-center text-sm text-muted-foreground">
          <a
            href="https://layout.dev"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 hover:text-accent transition-colors"
          >
            Made with <Heart className="w-4 h-4 fill-destructive text-destructive animate-pulse" /> by{' '}
            <span className="font-semibold bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent">
              Layout.dev
            </span>
          </a>
        </div>

        {/* Copyright */}
        <div className="text-center text-xs text-muted-foreground/60 mt-4">
          © {new Date().getFullYear()} Layout.dev. All rights reserved.
        </div>
      </div>
    </footer>
  );
};
